export default "__VITE_ASSET__Bg9_3YqJ__"